export const priceFunData = {
  b2c: [
    {
      title: "price.compare.authentication.title",
      active: true,
      des: [
        "price.compare.authentication.feature1.des",
        "price.compare.authentication.feature2.des",
        "price.compare.authentication.feature3.des",
        "price.compare.authentication.feature4.des",
        "price.compare.authentication.feature5.des",
        // "price.compare.authentication.feature6.des",
        "price.compare.authentication.feature7.des",
        "price.compare.authentication.feature8.des",
        "price.compare.authentication.feature9.des",
        "price.compare.authentication.feature10.des",
        "price.compare.authentication.feature11.des",
      ],
      list: [
        [
          "price.compare.authentication.feature1.title",
          "price.compare.authentication.feature1.b2c.free",
          "price.compare.authentication.feature1.b2c.develop",
          "price.compare.authentication.feature1.b2c.developPro",
          "price.compare.authentication.feature1.enterprise",
        ],
        [
          "price.compare.authentication.feature2.title",
          "-",
          "-",
          "-",
          "price.compare.authentication.feature2.enterprise",
        ],
        [
          "price.compare.authentication.feature3.title",
          "1",
          "price.compare.authentication.feature3.b2c.develop",
          "price.compare.authentication.feature3.b2c.developPro",
          "price.compare.authentication.feature3.enterprise",
        ],
        [
          "price.compare.authentication.feature4.title",
          "-",
          "-",
          "-",
          "price.compare.authentication.feature4.enterprise",
        ],
        [
          "price.compare.authentication.feature5.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
        // [
        //   "price.compare.authentication.feature6.title",
        //   "-",
        //   "checked",
        //   "checked",
        //   "checked",
        // ],
        [
          "price.compare.authentication.feature7.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.authentication.feature8.title",
          "-",
          "-",
          "-",
          "checked",
        ],
        [
          "price.compare.authentication.feature9.title",
          "1",
          "10",
          "20",
          "price.compare.authentication.feature9.enterprise",
        ],
        [
          "price.compare.authentication.feature10.title",
          "-",
          "-",
          "-",
          "price.compare.authentication.feature10.enterprise",
        ],
        [
          "price.compare.authentication.feature11.title",
          "-",
          "-",
          "-",
          "checked",
        ],
      ],
    },
    {
      title: "price.compare.brand.title",
      active: false,
      des: [
        "price.compare.brand.feature1.des",
        "price.compare.brand.feature2.des",
        "price.compare.brand.feature3.des",
        "price.compare.authentication.feature6.des",
      ],
      list: [
        [
          "price.compare.brand.feature1.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.brand.feature2.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.brand.feature3.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.authentication.feature6.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
      ],
    },
    {
      title: "price.compare.automation.title",
      active: false,
      des: [
        "price.compare.automation.feature1.des",
        "price.compare.automation.feature2.des",
      ],
      list: [
        [
          "price.compare.automation.feature1.title",
          "-",
          "5",
          "10",
          "price.compare.automation.feature1.enterprise",
        ],
        [
          "Webhooks",
          "-",
          "5",
          "10",
          "price.compare.automation.feature2.enterprise",
        ],
      ],
    },
    {
      title: "price.compare.security.title",
      active: false,
      des: [
        "price.compare.security.feature1.des",
        "price.compare.security.feature2.des",
        "price.compare.security.feature3.des",
        "price.compare.security.feature4.des",
        "price.compare.security.feature5.des",
        "price.compare.security.feature6.des",
      ],
      list: [
        [
          "price.compare.security.feature1.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.security.feature2.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.security.feature3.title",
          "-",
          "price.compare.security.feature3.b2c.develop",
          "price.compare.security.feature3.b2c.developPro",
          "price.compare.security.feature3.enterprise",
        ],
        [
          "price.compare.security.feature4.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.security.feature5.title",
          "-",
          "-",
          "1",
          "price.compare.security.feature5.enterprise",
        ],
        [
          "price.compare.security.feature6.title",
          "-",
          "5",
          "10",
          "price.compare.security.feature6.enterprise",
        ],
      ],
    },
    {
      title: "price.compare.user-directory.title",
      active: false,
      des: [
        "price.compare.user-directory.feature1.des",
        "price.compare.user-directory.feature2.des",
        "price.compare.user-directory.feature9.des",
        "price.compare.user-directory.feature10.des",
        "price.compare.user-directory.feature3.des",
        "price.compare.user-directory.feature4.des",
        "price.compare.user-directory.feature5.des",
        "price.compare.user-directory.feature6.des",
        "price.compare.user-directory.feature7.des",
        "price.compare.user-directory.feature8.des",
        "price.compare.user-directory.feature11.des",
      ],
      list: [
        [
          "price.compare.user-directory.feature1.title",
          "checked",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature2.title",
          "-",
          "5",
          "10",
          "price.compare.user-directory.feature2.enterprise",
        ],
        [
          "price.compare.user-directory.feature9.title",
          "-",
          "5",
          "10",
          "price.compare.user-directory.feature9.enterprise",
        ],
        [
          "price.compare.user-directory.feature10.title",
          "-",
          "5",
          "10",
          "price.compare.user-directory.feature10.enterprise",
        ],
        [
          "price.compare.user-directory.feature3.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature4.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature5.title",
          "-",
          "-",
          "-",
          "checked",
        ],
        [
          "price.compare.user-directory.feature6.title",
          "-",
          "-",
          "-",
          "checked",
        ],
        [
          "price.compare.user-directory.feature7.title",
          "-",
          "-",
          "-",
          "price.compare.user-directory.feature7.enterprise",
        ],
        [
          "price.compare.user-directory.feature8.title",
          "-",
          "-",
          "-",
          "checked",
        ],
        [
          "price.compare.user-directory.feature11.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
      ],
    },
    {
      title: "price.compare.service-support.title",
      active: false,
      des: [
        "price.compare.service-support.feature1.des",
        "price.compare.service-support.feature2.des",
        "price.compare.service-support.feature3.des",
        "price.compare.service-support.feature4.des",
        "price.compare.service-support.feature5.des",
        "price.compare.service-support.feature6.des",
        "price.compare.service-support.feature7.des",
      ],
      list: [
        [
          "price.compare.service-support.feature1.title",
          "price.compare.service-support.feature1.b2c.free",
          "price.compare.service-support.feature1.b2c.develop",
          "price.compare.service-support.feature1.b2c.developPro",
          "price.compare.service-support.feature1.enterprise",
        ],
        [
          "price.compare.service-support.feature2.title",
          "-",
          "-",
          "99.9%",
          "99.99%",
        ],
        [
          "price.compare.service-support.feature3.title",
          "-",
          "8*5",
          "12*7",
          "24*7",
        ],
        [
          "price.compare.service-support.feature4.title",
          "-",
          "price.compare.service-support.feature4.b2c.develop",
          "price.compare.service-support.feature4.b2c.developPro",
          "price.compare.service-support.feature4.enterprise",
        ],
        [
          "price.compare.service-support.feature5.title",
          "checked",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.service-support.feature6.title",
          "-",
          "-",
          "-",
          "checked",
        ],
        [
          "price.compare.service-support.feature7.title",
          "-",
          "-",
          "-",
          "price.compare.service-support.feature7.enterprise",
        ],
      ],
    },
  ],
  b2b: [
    {
      title: "price.compare.authentication.title",
      active: true,
      des: [
        "price.compare.authentication.feature1.des",
        "price.compare.authentication.feature2.des",
        "price.compare.authentication.feature3.des",
        "price.compare.authentication.feature4.des",
        "price.compare.authentication.feature5.des",
        // "price.compare.authentication.feature6.des",
        "price.compare.authentication.feature7.des",
        "price.compare.authentication.feature8.des",
        "price.compare.authentication.feature9.des",
        "price.compare.authentication.feature10.des",
        "price.compare.authentication.feature11.des",
      ],
      list: [
        [
          "price.compare.authentication.feature1.title",
          "price.compare.authentication.feature1.b2b.free",
          "price.compare.authentication.feature1.b2b.develop",
          "price.compare.authentication.feature1.b2b.developPro",
          "price.compare.authentication.feature1.enterprise",
        ],
        [
          "price.compare.authentication.feature2.title",
          "-",
          "-",
          "-",
          "price.compare.authentication.feature2.enterprise",
        ],
        [
          "price.compare.authentication.feature3.title",
          "1",
          "price.compare.authentication.feature3.b2b.develop",
          "price.compare.authentication.feature3.b2b.developPro",
          "price.compare.authentication.feature3.enterprise",
        ],
        [
          "price.compare.authentication.feature4.title",
          "-",
          "1",
          "3",
          "price.compare.authentication.feature4.enterprise",
        ],
        [
          "price.compare.authentication.feature5.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        // [
        //   "price.compare.authentication.feature6.title",
        //   "checked",
        //   "checked",
        //   "checked",
        //   "checked",
        // ],
        [
          "price.compare.authentication.feature7.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.authentication.feature8.title",
          "-",
          "-",
          "-",
          "checked",
        ],
        [
          "price.compare.authentication.feature9.title",
          "1",
          "10",
          "20",
          "price.compare.authentication.feature9.enterprise",
        ],
        [
          "price.compare.authentication.feature10.title",
          "-",
          "-",
          "20",
          "price.compare.authentication.feature10.enterprise",
        ],
        [
          "price.compare.authentication.feature11.title",
          "-",
          "-",
          "-",
          "checked",
        ],
      ],
    },
    {
      title: "price.compare.brand.title",
      active: false,
      des: [
        "price.compare.brand.feature1.des",
        "price.compare.brand.feature2.des",
        "price.compare.brand.feature3.des",
        "price.compare.authentication.feature6.des",
      ],
      list: [
        [
          "price.compare.brand.feature1.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.brand.feature2.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.brand.feature3.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.authentication.feature6.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
      ],
    },
    {
      title: "price.compare.automation.title",
      active: false,
      des: [
        "price.compare.automation.feature1.des",
        "price.compare.automation.feature2.des",
      ],
      list: [
        [
          "price.compare.automation.feature1.title",
          "-",
          "5",
          "10",
          "price.compare.automation.feature1.enterprise",
        ],
        [
          "Webhooks",
          "-",
          "5",
          "10",
          "price.compare.automation.feature2.enterprise",
        ],
      ],
    },
    {
      title: "price.compare.security.title",
      active: false,
      des: [
        "price.compare.security.feature1.des",
        "price.compare.security.feature2.des",
        "price.compare.security.feature3.des",
        "price.compare.security.feature4.des",
        "price.compare.security.feature5.des",
        "price.compare.security.feature6.des",
      ],
      list: [
        [
          "price.compare.security.feature1.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.security.feature2.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.security.feature3.title",
          "-",
          "price.compare.security.feature3.b2b.develop",
          "price.compare.security.feature3.b2b.developPro",
          "price.compare.security.feature3.enterprise",
        ],
        [
          "price.compare.security.feature4.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.security.feature5.title",
          "-",
          "-",
          "1",
          "price.compare.security.feature5.enterprise",
        ],
        [
          "price.compare.security.feature6.title",
          "-",
          "5",
          "10",
          "price.compare.security.feature6.enterprise",
        ],
      ],
    },
    {
      title: "price.compare.user-directory.title",
      active: false,
      des: [
        "price.compare.user-directory.feature1.des",
        "price.compare.user-directory.feature2.des",
        "price.compare.user-directory.feature9.des",
        "price.compare.user-directory.feature10.des",
        "price.compare.user-directory.feature3.des",
        "price.compare.user-directory.feature4.des",
        "price.compare.user-directory.feature5.des",
        "price.compare.user-directory.feature6.des",
        "price.compare.user-directory.feature7.des",
        "price.compare.user-directory.feature8.des",
        "price.compare.user-directory.feature11.des",
      ],
      list: [
        [
          "price.compare.user-directory.feature1.title",
          "checked",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature2.title",
          "-",
          "5",
          "10",
          "price.compare.user-directory.feature2.enterprise",
        ],
        [
          "price.compare.user-directory.feature9.title",
          "-",
          "5",
          "10",
          "price.compare.user-directory.feature9.enterprise",
        ],
        [
          "price.compare.user-directory.feature10.title",
          "-",
          "5",
          "10",
          "price.compare.user-directory.feature10.enterprise",
        ],
        [
          "price.compare.user-directory.feature3.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature4.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature5.title",
          "-",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature6.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature7.title",
          "3",
          "50",
          "100",
          "price.compare.user-directory.feature7.enterprise",
        ],
        [
          "price.compare.user-directory.feature8.title",
          "-",
          "-",
          "-",
          "checked",
        ],
        [
          "price.compare.user-directory.feature11.title",
          "-",
          "-",
          "checked",
          "checked",
        ],
      ],
    },
    {
      title: "price.compare.service-support.title",
      active: false,
      des: [
        "price.compare.service-support.feature1.des",
        "price.compare.service-support.feature2.des",
        "price.compare.service-support.feature3.des",
        "price.compare.service-support.feature4.des",
        "price.compare.service-support.feature5.des",
        "price.compare.service-support.feature6.des",
        "price.compare.service-support.feature7.des",
      ],
      list: [
        [
          "price.compare.service-support.feature1.title",
          "price.compare.service-support.feature1.b2b.free",
          "price.compare.service-support.feature1.b2b.develop",
          "price.compare.service-support.feature1.b2b.developPro",
          "price.compare.service-support.feature1.enterprise",
        ],
        [
          "price.compare.service-support.feature2.title",
          "-",
          "-",
          "99.9%",
          "99.99%",
        ],
        [
          "price.compare.service-support.feature3.title",
          "-",
          "8*5",
          "12*7",
          "24*7",
        ],
        [
          "price.compare.service-support.feature4.title",
          "-",
          "price.compare.service-support.feature4.b2b.develop",
          "price.compare.service-support.feature4.b2b.developPro",
          "price.compare.service-support.feature4.enterprise",
        ],
        [
          "price.compare.service-support.feature5.title",
          "checked",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.service-support.feature6.title",
          "-",
          "-",
          "-",
          "checked",
        ],
        [
          "price.compare.service-support.feature7.title",
          "-",
          "-",
          "-",
          "price.compare.service-support.feature7.enterprise",
        ],
      ],
    },
  ],
  b2e: [
    {
      title: "price.compare.authentication.title",
      active: true,
      des: [
        "price.compare.authentication.feature1.des",
        "price.compare.authentication.feature2.des",
        "price.compare.authentication.feature3.des",
        "price.compare.authentication.feature4.des",
        "price.compare.authentication.feature5.des",
        // "price.compare.authentication.feature6.des",
        "price.compare.authentication.feature7.des",
        "price.compare.authentication.feature8.des",
        "price.compare.authentication.feature9.des",
        "price.compare.authentication.feature10.des",
        "price.compare.authentication.feature11.des",
      ],
      list: [
        [
          "price.compare.authentication.feature1.title",
          "-",
          "-",
          "price.compare.authentication.feature1.enterprise",
        ],
        [
          "price.compare.authentication.feature2.title",
          "price.compare.authentication.feature2.b2e.free",
          "price.compare.authentication.feature2.b2e.develop",
          "price.compare.authentication.feature2.enterprise",
        ],
        [
          "price.compare.authentication.feature3.title",
          "1",
          "price.compare.authentication.feature3.b2e.develop",
          "price.compare.authentication.feature3.enterprise",
        ],
        [
          "price.compare.authentication.feature4.title",
          "1",
          "3",
          "price.compare.authentication.feature4.enterprise",
        ],
        [
          "price.compare.authentication.feature5.title",
          "-",
          "checked",
          "checked",
        ],
        // [
        //   "price.compare.authentication.feature6.title",
        //   "checked",
        //   "checked",
        //   "checked",
        // ],
        [
          "price.compare.authentication.feature7.title",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.authentication.feature8.title",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.authentication.feature9.title",
          "1",
          "10",
          "price.compare.authentication.feature9.enterprise",
        ],
        [
          "price.compare.authentication.feature10.title",
          "3",
          "10",
          "price.compare.authentication.feature10.enterprise",
        ],
        [
          "price.compare.authentication.feature11.title",
          "-",
          "checked",
          "checked",
        ],
      ],
    },
    {
      title: "price.compare.brand.title",
      active: false,
      des: [
        "price.compare.brand.feature1.des",
        "price.compare.brand.feature2.des",
        "price.compare.brand.feature3.des",
        "price.compare.authentication.feature6.des",
      ],
      list: [
        ["price.compare.brand.feature1.title", "-", "checked", "checked"],
        ["price.compare.brand.feature2.title", "-", "checked", "checked"],
        ["price.compare.brand.feature3.title", "-", "checked", "checked"],
        [
          "price.compare.authentication.feature6.title",
          "-",
          "checked",
          "checked",
        ],
      ],
    },
    {
      title: "price.compare.automation.title",
      active: false,
      des: [
        "price.compare.automation.feature1.des",
        "price.compare.automation.feature2.des",
        "price.compare.automation.feature3.des",
      ],
      list: [
        [
          "price.compare.automation.feature1.title",
          "-",
          "10",
          "price.compare.automation.feature1.enterprise",
        ],
        ["Webhooks", "-", "10", "price.compare.automation.feature2.enterprise"],
      ],
    },
    {
      title: "price.compare.security.title",
      active: false,
      des: [
        "price.compare.security.feature1.des",
        "price.compare.security.feature2.des",
        "price.compare.security.feature3.des",
        "price.compare.security.feature4.des",
        "price.compare.security.feature5.des",
        "price.compare.security.feature6.des",
      ],
      list: [
        ["price.compare.security.feature1.title", "-", "checked", "checked"],
        ["price.compare.security.feature2.title", "-", "checked", "checked"],
        [
          "price.compare.security.feature3.title",
          "-",
          "price.compare.security.feature3.b2e.develop",
          "price.compare.security.feature3.enterprise",
        ],
        ["price.compare.security.feature4.title", "-", "checked", "checked"],
        [
          "price.compare.security.feature5.title",
          "-",
          "1",
          "price.compare.security.feature5.enterprise",
        ],
        [
          "price.compare.security.feature6.title",
          "-",
          "10",
          "price.compare.security.feature6.enterprise",
        ],
      ],
    },
    {
      title: "price.compare.user-directory.title",
      active: false,
      des: [
        "price.compare.user-directory.feature1.des",
        "price.compare.user-directory.feature2.des",
        "price.compare.user-directory.feature9.des",
        "price.compare.user-directory.feature10.des",
        "price.compare.user-directory.feature3.des",
        "price.compare.user-directory.feature4.des",
        "price.compare.user-directory.feature5.des",
        "price.compare.user-directory.feature6.des",
        "price.compare.user-directory.feature7.des",
        "price.compare.user-directory.feature8.des",
        "price.compare.user-directory.feature11.des",
      ],
      list: [
        [
          "price.compare.user-directory.feature1.title",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature2.title",
          "-",
          "10",
          "price.compare.user-directory.feature2.enterprise",
        ],
        [
          "price.compare.user-directory.feature9.title",
          "-",
          "10",
          "price.compare.user-directory.feature9.enterprise",
        ],
        [
          "price.compare.user-directory.feature10.title",
          "-",
          "10",
          "price.compare.user-directory.feature10.enterprise",
        ],
        [
          "price.compare.user-directory.feature3.title",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature4.title",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature5.title",
          "checked",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature6.title",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature7.title",
          "-",
          "-",
          "price.compare.user-directory.feature7.enterprise",
        ],
        [
          "price.compare.user-directory.feature8.title",
          "-",
          "checked",
          "checked",
        ],
        [
          "price.compare.user-directory.feature11.title",
          "-",
          "checked",
          "checked",
        ],
      ],
    },
    {
      title: "price.compare.service-support.title",
      active: false,
      des: [
        "price.compare.service-support.feature1.des",
        "price.compare.service-support.feature2.des",
        "price.compare.service-support.feature3.des",
        "price.compare.service-support.feature4.des",
        "price.compare.service-support.feature5.des",
        "price.compare.service-support.feature6.des",
        "price.compare.service-support.feature7.des",
      ],
      list: [
        [
          "price.compare.service-support.feature1.title",
          "price.compare.service-support.feature1.b2e.free",
          "price.compare.service-support.feature1.b2e.develop",
          "price.compare.service-support.feature1.enterprise",
        ],
        [
          "price.compare.service-support.feature2.title",
          "-",
          "99.9%",
          "99.99%",
        ],
        ["price.compare.service-support.feature3.title", "-", "12*7", "24*7"],
        [
          "price.compare.service-support.feature4.title",
          "-",
          "price.compare.service-support.feature4.b2e.develop",
          "price.compare.service-support.feature4.enterprise",
        ],
        [
          "price.compare.service-support.feature5.title",
          "checked",
          "checked",
          "checked",
        ],
        ["price.compare.service-support.feature6.title", "-", "-", "checked"],
        [
          "price.compare.service-support.feature7.title",
          "-",
          "-",
          "price.compare.service-support.feature7.enterprise",
        ],
      ],
    },
  ],
};
